<ng-container *ngIf="(sourceMarqueurs | sourceMarqueursIntoLegend:fixedLegend) as legend">
  <ion-item *ngIf="legend.length > 0" lines="none">
    <div style="width: 100%; margin-bottom: 8px;">
      <h3>Légende</h3>
      <ng-container *ngFor="let legendElement of legend; let i = index; trackBy: trackByIndex">

        <ng-container *ngIf="i | elementEditionOn:ongoingEditedElements; else EditionOff">
          <p style="text-align:center;">
            <strong>{{ i + 1 }} : </strong> <ion-input class="gl-input-highlight c-ion-input" (ionInput)="editDescription($event, legendElement, i)" type="text" [value]="legendElement.description"></ion-input> <button class="c-edit-element-button" (click)="toggleEditableMode(i)"><ion-icon name="checkmark-outline"></ion-icon></button>
          </p>
        </ng-container>

        <ng-template #EditionOff>
          <p style="text-align:center;">
            <strong>{{ i + 1 }} : </strong> {{ legendElement.description || '-' }} <button *ngIf="i >= fixedLegend.length && !modeShow" class="c-edit-element-button" (click)="toggleEditableMode(i)"><ion-icon name="create-outline"></ion-icon></button>
          </p>
        </ng-template>

      </ng-container>
    </div>
  </ion-item>
</ng-container>

